{
  "version": 1,
  "asset_id": "b7f23b01-fa33-45e7-8486-d5b43ac29d5e",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/b7f23b01-fa33-45e7-8486-d5b43ac29d5e/hiatal-type-4-v3-1200.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/b7f23b01-fa33-45e7-8486-d5b43ac29d5e/hiatal-type-4-v3-1200.jpg",
  "original_filename": "hiatal-type-4-v3-1200.jpg",
  "size": 255310,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T23:03:45Z"
}
